export default __webpack_public_path__ + "static/media/feature-1.2e0fab95.svg";